module.exports = __webpack_public_path__ + "media/images/download/e-book14-5db26d1da7df737862e61915ced068b6.png";